<app-navbar></app-navbar>

<div class="dashboard-full-width">
  <div class="">
    <div class="main-container-dashboard">
      <!-- <app-samplecenter-sidebar></app-samplecenter-sidebar> -->

      <div class="card shadow custom-margin-right-box" style="width: 100%">
        <div class="card-header heading_n_button_box">
          <div class="card-heading">
            <h4>List of Logged Samples</h4>
          </div>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-lg-12">
              <form
                [formGroup]="searchForm"
                (ngSubmit)="onSubmitSearch(searchForm.value)"
              >
                <div class="row">
                  <div class="col-lg-3  col-sm-6  col-md-6  mt-320_view">
                    <select
                      class="form-select select-option col-lg-12"
                      formControlName="traveller"
                      aria-label="Default select example"
                    >
                      <option value="" selected="selected">
                        Type of Traveller
                      </option>
                      <option value="2">Arriving Equitorial Guinea</option>
                      <option value="1">Departing Equitorial Guinea</option>
                    </select>
                  </div>
                  <div class="col-lg-3  col-sm-6  col-md-6  mt-320_view">
                    <div class="form-group">
                      <div class="input-group">
                        <input
                          class="form-control icon-cal font-12"
                          type="text"
                          formControlName="daterangeInput"
                          placeholder="Enrollment: Date From - Date To"
                          daterangepicker
                          [options]="options"
                          (selected)="selectedDate($event, daterange)"
                          title="Enrollment: Date From - Date To"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-3">
                    <select
                      class="form-select select-option col-lg-12"
                      formControlName="status"
                      aria-label="Default select example"
                    >
                      <option value="" selected="selected">
                        Payment Status
                      </option>
                      <option value="1">Paid</option>
                      <option value="0">Unpaid</option>
                    </select>
                  </div>
                  <div class="col-lg-3  col-sm-6  col-md-6  mt-320_view">
                    <div class="mr-4">
                      <button
                        class="btn btn-secondary theme-btn-2 dropdown-toggle-no"
                        type="submit"
                        id="dropdownMenuButton"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        <i class="fas fa-search"></i> Search
                      </button>

                      <button
                        class="
                          btn btn-secondary
                          theme-btn-2
                          dropdown-toggle-no
                          ml-2
                        "
                        type="button"
                        id="dropdownMenuButton"
                        aria-haspopup="true"
                        aria-expanded="false"
                        (click)="clearSearch()"
                      >
                        <i class="fas fa-sync-alt"></i> Clear
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>

            <!-- <h3 class="dashboard-heading-1">Passenger personal Information</h3> -->
            <div class="col-lg-12 mt-4">
              <div class="col-auto">
                <div class="row" *ngIf="loggedSamples">
                  <div class="show-record mt-3 mbm-32">
                    <span>Show</span> &nbsp;
                    <select
                      class="
                        custom-select custom-select-sm
                        form-control form-control-sm
                      "
                      (change)="setItemsPerPage(page.value)"
                      #page
                    >
                      <option [selected]="currentPageLength == 10">10</option>
                      <option [selected]="currentPageLength == 30">30</option>
                      <option [selected]="currentPageLength == 50">50</option>
                      <option [selected]="currentPageLength == 100">100</option>
                      <option [selected]="currentPageLength == 500">500</option>
                      <option [selected]="currentPageLength == 1000">
                        1000
                      </option>
                    </select>
                    &nbsp;
                    <span> entries</span>
                  </div>
                </div>
              </div>
              <div class="table table-responsive">
                <table
                  class="
                    table
                    table-bordered
                    table-condensed
                    table-responsive-sm
                    table-responsive-md
                    table-responsive-lg
                    table-responsive-xl
                    nowrap
                  "
                  datatable
                  [dtOptions]="dtOptions"
                  width="100%"
                  *ngIf="loggedSamples"
                >
                  <thead class="">
                    <tr>
                      <th scope="col">S/N</th>
                      <th scope="col">Appointment ID</th>
                      <th scope="col">Surname</th>
                      <th scope="col">First Name</th>
                      <th scope="col">Middle Name</th>
                      <!-- <th scope="col">Passport No</th> -->
                      <th scope="col">Type Of Traveller</th>
                      <th scope="col">Phone Number</th>
                      <th scope="col">Enrollment Date</th>
                      <th scope="col">Sample Collection Date</th>
                      <th scope="col">Payment Status</th>
                      <th scope="col">Action</th>
                    </tr>
                  </thead>
                  <tbody class="dashboard-bg-white">
                    <tr
                      *ngFor="
                        let item of loggedSamples | paginate: config;
                        index as i
                      "
                    >
                      <th scope="row">
                        {{
                          config.itemsPerPage * (config.currentPage - 1) + i + 1
                        }}
                      </th>
                      <td>{{ item.ctms_passenger_id }}</td>
                      <td>{{ item.last_name }}</td>
                      <td>{{ item.first_name }}</td>
                      <td>{{ item.middle_name }}</td>
                      <!-- <td>{{item.passport_no}}</td> -->
                      <td>{{ item.type == 2 ? "ARRIVING" : "DEPARTING" }}</td>
                      <td>{{ item.phone }}</td>
                      <td>{{ item.created_at | date }}</td>
                      <td>
                        {{
                          item.booking_date + " " + item.booking_time
                            | date: "MMM, dd, yyyy, hh:mm a"
                        }}
                      </td>

                      <td>
                        <span
                          *ngIf="item.payment_status"
                          class="text-success"
                          >Paid</span
                        >
                        <span
                          *ngIf="!item.payment_status"
                          class="text-warning"
                          >Unpaid</span
                        >
                      </td>

                      <td>
                        <button
                          title="View"
                          class="btn-view"
                          (click)="showModal(sampleModal, item)"
                        >
                          <i class="far fa-eye"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class="table-footer">
                  <div
                    id="page_info"
                    class="mt-3 record-show-text-bottom"
                    *ngIf="loggedSamples"
                  >
                    Showing
                    {{ (config.currentPage - 1) * config.itemsPerPage + 1 }} -
                    {{ config.currentPage * config.itemsPerPage }} of
                    {{ config.totalItems }} entries
                  </div>

                  <div
                    class="pagination paging-pull-right"
                    *ngIf="loggedSamples"
                  >
                    <pagination-controls
                      (pageChange)="pageChange($event)"
                      class="my-pagination mt-2 pagination-server"
                    >
                    </pagination-controls>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #sampleModal let-modal>
  <div class="row">
    <div class="col-lg-12 mb-3">
      <div
        class="
          card-header
          col-lg-12
          heading_n_button_box
          header-dashboard-button-2
        "
      >
        <h3>Logged Sample</h3>
        <button class="close-button" (click)="modal.close('Save click')">
          <i class="fas fa-times"></i>
        </button>
      </div>

      <div class="card-body p-4">
        <form [formGroup]="singleSampleForm">
          <div class="row">
            <div class="col-md-8 offset-md-2">
              <div class="form-group row">
                <label for="appointmenId" class="col-md-4 col-form-label"
                  >Appointment ID</label
                >
                <div class="col-md-8">
                  <input
                    type="text"
                    class="form-control"
                    disabled
                    formControlName="appointmentId"
                    name="appointmentId"
                  />
                </div>
              </div>
              <div class="form-group row">
                <label for="fullname" class="col-md-4 col-form-label"
                  >Full name</label
                >
                <div class="col-md-8">
                  <input
                    type="text"
                    class="form-control"
                    disabled
                    formControlName="fullname"
                    name=""
                  />
                </div>
              </div>
              <div class="form-group row">
                <label for="phone" class="col-md-4 col-form-label"
                  >Phone number</label
                >
                <div class="col-md-8">
                  <input
                    type="text"
                    class="form-control"
                    disabled
                    formControlName="phone"
                    name=""
                  />
                </div>
              </div>
              <div class="form-group row">
                <label for="traveller" class="col-md-4 col-form-label"
                  >Travel type</label
                >
                <div class="col-md-8">
                  <input
                    type="text"
                    class="form-control"
                    disabled
                    formControlName="traveller"
                    name=""
                  />
                </div>
              </div>
              <div class="form-group row">
                <label for="date" class="col-md-4 col-form-label"
                  >Collection Date</label
                >
                <div class="col-md-8">
                  <input
                    type="text"
                    class="form-control"
                    disabled
                    formControlName="date"
                    name=""
                  />
                </div>
              </div>
              <div class="form-group row">
                <label for="status" class="col-md-4 col-form-label"
                  >Payment Status</label
                >
                <div class="col-md-8">
                  <input
                    type="text"
                    class="form-control"
                    disabled
                    formControlName="status"
                    name=""
                  />
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</ng-template>

<app-footer-dashboard></app-footer-dashboard>
